const values = {
    HOST: 'https://6hvg3eqzx0.execute-api.us-east-1.amazonaws.com/prod',
    // HOST: 'http://localhost:8084',
};

export default values;
